import { Component, OnInit } from "@angular/core";
import { debounceTime } from "rxjs/operators";
import { fromEvent } from "rxjs";
import * as $ from "jquery";
// import {HeaderComponent} from "../header/header.component";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
})
export class FooterComponent implements OnInit {
  isShow = false;

  ngOnInit() {
    // super.ngOnInit();
    fromEvent(document, "scroll")
      .pipe(debounceTime(100))
      .subscribe((event) => {
        this.isShow = $(window).scrollTop() >= 300;
      });
  }

  // Scroll to the top of the document with smooth animation
  topFunction() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }
}
